import PageTitleBar from './PageTitleBar';

export default PageTitleBar;
